import { useNavigate } from 'react-router-dom';

export const BackButton = ({ to, onBack }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) { onBack(); return; }
    if (to) navigate(to);
    else navigate(-1);
  };

  return (
    <div className="inline-flex rounded-sm hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 cursor-pointer">
      <button
        onClick={handleBack}
        aria-label="Go back"
        className="p-2 flex items-center justify-center"
      >
        <svg
          className="w-6 h-6 text-gray-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
    </div>
  );
};

export default BackButton;